/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-factory.js to modify the generation of this file.
import Accordion from '../components/Accordion';
import AccordionSection from '../components/AccordionSection';
import AlertRibbon from '../components/AlertRibbon';
import ArticleGrid from '../components/ArticleGrid';
import BlogAccordion from '../components/BlogAccordion';
import BlogAccordionSection from '../components/BlogAccordionSection';
import BlueyBeanChallenge from '../components/BlueyBeanChallenge';
import CallToAction from '../components/CallToAction';
import ContactRepForm from '../components/ContactRepForm';
import ContactUsForm from '../components/ContactUsForm';
import ContentBlock from '../components/ContentBlock';
import ContentCard from '../components/ContentCard';
import ContentCardContainer from '../components/ContentCardContainer';
import ContentComponent from '../components/ContentComponent';
import CookiePolicy from '../components/CookiePolicy';
import FavoritesGrid from '../components/FavoritesGrid';
import FeaturedDetailHero from '../components/FeaturedDetailHero';
import FeaturedDetailHeroWithVideo from '../components/FeaturedDetailHeroWithVideo';
import FeaturedFacts from '../components/FeaturedFacts';
import FeaturedRecipePromo from '../components/FeaturedRecipePromo';
import FindInStoreSearchDestiny from '../components/FindInStoreSearchDestiny';
import FindNearYou from '../components/FindNearYou';
import Footer from '../components/Footer';
import HeroCarousel from '../components/HeroCarousel';
import HeroCarouselSlide from '../components/HeroCarouselSlide';
import HeroWithTextLeft from '../components/HeroWithTextLeft';
import HomepageHeroCarousel from '../components/HomepageHeroCarousel';
import HomepageHeroCarouselSlide from '../components/HomepageHeroCarouselSlide';
import InRecipeProductsFoodservices from '../components/InRecipeProductsFoodservices';
import InRecipeProductsPromo from '../components/InRecipeProductsPromo';
import LandingHero from '../components/LandingHero';
import MainNav from '../components/MainNav';
import MediaCarousel from '../components/MediaCarousel';
import MediaCarouselImageSlide from '../components/MediaCarouselImageSlide';
import MediaCarouselVideoSlide from '../components/MediaCarouselVideoSlide';
import NotFound from '../components/NotFound';
import NutritionLabelTable from '../components/NutritionLabelTable';
import OffsetFeaturePromo from '../components/OffsetFeaturePromo';
import ProductCTA from '../components/ProductCTA';
import ProductDescription from '../components/ProductDescription';
import ProductDetailHero from '../components/ProductDetailHero';
import ProductGrid from '../components/ProductGrid';
import ProductIngredientBenefitsPromo from '../components/ProductIngredientBenefitsPromo';
import ProductListCarousel from '../components/ProductListCarousel';
import ProductNutritionLabelPromo from '../components/ProductNutritionLabelPromo';
import RecipeDirectionDetails from '../components/RecipeDirectionDetails';
import RecipeGrid from '../components/RecipeGrid';
import RecipeIngredientsDetails from '../components/RecipeIngredientsDetails';
import RecipeOverview from '../components/RecipeOverview';
import RecommendRecipe from '../components/RecommendRecipe';
import RelatedCarousel from '../components/RelatedCarousel';
import RelatedCarouselSlide from '../components/RelatedCarouselSlide';
import RelatedPagesPromo from '../components/RelatedPagesPromo';
import ScrollingImagesPromo from '../components/ScrollingImagesPromo';
import ScrollingImagesPromoSlide from '../components/ScrollingImagesPromoSlide';
import ScrollingVanityTextWithVideo from '../components/ScrollingVanityTextWithVideo';
import SearchBox from '../components/SearchBox';
import SideBySide from '../components/SideBySide';
import SideBySideLargeImage from '../components/SideBySideLargeImage';
import SideBySideRevealImage from '../components/SideBySideRevealImage';
import SiteSearchResults from '../components/SiteSearchResults';
import SocialShare from '../components/SocialShare';
import SocialVideo from '../components/SocialVideo';
import SocialVideoSlide from '../components/SocialVideoSlide';
import TestimonialCarousel from '../components/TestimonialCarousel';
import TestimonialCarouselSlide from '../components/TestimonialCarouselSlide';
import Text from '../components/Text';
import TextLeftVideoRight from '../components/TextLeftVideoRight';
import ThreeColShowcase from '../components/ThreeColShowcase';
import UtilityNav from '../components/UtilityNav';
import VendorForm from '../components/VendorForm';
import VerticalEmbeds from '../components/VerticalEmbeds';

const components = new Map();
components.set('Accordion', Accordion);
components.set('AccordionSection', AccordionSection);
components.set('AlertRibbon', AlertRibbon);
components.set('ArticleGrid', ArticleGrid);
components.set('BlogAccordion', BlogAccordion);
components.set('BlogAccordionSection', BlogAccordionSection);
components.set('BlueyBeanChallenge', BlueyBeanChallenge);
components.set('CallToAction', CallToAction);
components.set('ContactRepForm', ContactRepForm);
components.set('ContactUsForm', ContactUsForm);
components.set('ContentBlock', ContentBlock);
components.set('ContentCard', ContentCard);
components.set('ContentCardContainer', ContentCardContainer);
components.set('ContentComponent', ContentComponent);
components.set('CookiePolicy', CookiePolicy);
components.set('FavoritesGrid', FavoritesGrid);
components.set('FeaturedDetailHero', FeaturedDetailHero);
components.set('FeaturedDetailHeroWithVideo', FeaturedDetailHeroWithVideo);
components.set('FeaturedFacts', FeaturedFacts);
components.set('FeaturedRecipePromo', FeaturedRecipePromo);
components.set('FindInStoreSearchDestiny', FindInStoreSearchDestiny);
components.set('FindNearYou', FindNearYou);
components.set('Footer', Footer);
components.set('HeroCarousel', HeroCarousel);
components.set('HeroCarouselSlide', HeroCarouselSlide);
components.set('HeroWithTextLeft', HeroWithTextLeft);
components.set('HomepageHeroCarousel', HomepageHeroCarousel);
components.set('HomepageHeroCarouselSlide', HomepageHeroCarouselSlide);
components.set('InRecipeProductsFoodservices', InRecipeProductsFoodservices);
components.set('InRecipeProductsPromo', InRecipeProductsPromo);
components.set('LandingHero', LandingHero);
components.set('MainNav', MainNav);
components.set('MediaCarousel', MediaCarousel);
components.set('MediaCarouselImageSlide', MediaCarouselImageSlide);
components.set('MediaCarouselVideoSlide', MediaCarouselVideoSlide);
components.set('NotFound', NotFound);
components.set('NutritionLabelTable', NutritionLabelTable);
components.set('OffsetFeaturePromo', OffsetFeaturePromo);
components.set('ProductCTA', ProductCTA);
components.set('ProductDescription', ProductDescription);
components.set('ProductDetailHero', ProductDetailHero);
components.set('ProductGrid', ProductGrid);
components.set('ProductIngredientBenefitsPromo', ProductIngredientBenefitsPromo);
components.set('ProductListCarousel', ProductListCarousel);
components.set('ProductNutritionLabelPromo', ProductNutritionLabelPromo);
components.set('RecipeDirectionDetails', RecipeDirectionDetails);
components.set('RecipeGrid', RecipeGrid);
components.set('RecipeIngredientsDetails', RecipeIngredientsDetails);
components.set('RecipeOverview', RecipeOverview);
components.set('RecommendRecipe', RecommendRecipe);
components.set('RelatedCarousel', RelatedCarousel);
components.set('RelatedCarouselSlide', RelatedCarouselSlide);
components.set('RelatedPagesPromo', RelatedPagesPromo);
components.set('ScrollingImagesPromo', ScrollingImagesPromo);
components.set('ScrollingImagesPromoSlide', ScrollingImagesPromoSlide);
components.set('ScrollingVanityTextWithVideo', ScrollingVanityTextWithVideo);
components.set('SearchBox', SearchBox);
components.set('SideBySide', SideBySide);
components.set('SideBySideLargeImage', SideBySideLargeImage);
components.set('SideBySideRevealImage', SideBySideRevealImage);
components.set('SiteSearchResults', SiteSearchResults);
components.set('SocialShare', SocialShare);
components.set('SocialVideo', SocialVideo);
components.set('SocialVideoSlide', SocialVideoSlide);
components.set('TestimonialCarousel', TestimonialCarousel);
components.set('TestimonialCarouselSlide', TestimonialCarouselSlide);
components.set('Text', Text);
components.set('TextLeftVideoRight', TextLeftVideoRight);
components.set('ThreeColShowcase', ThreeColShowcase);
components.set('UtilityNav', UtilityNav);
components.set('VendorForm', VendorForm);
components.set('VerticalEmbeds', VerticalEmbeds);

export default function componentFactory(componentName) {
  return components.get(componentName);
};
